/**
 * Marketplace entry point.
 *
 * Everything here is progressive enhancement: every screen works server-rendered
 * without JavaScript, and this layer only removes round trips. Nothing in the
 * bundle is load-bearing for authentication or authorisation.
 */

import { initCitySuggest } from "./modules/city-suggest.js";
import { initConfirmDialogs } from "./modules/confirm-dialog.js";
import { headerHeight } from "./modules/header-height.js";
import { initRoleToggle } from "./modules/role-toggle.js";
import { initToasts } from "./modules/toasts.js";

function boot() {
  // First, and the order is the point. The stylesheet's fallback is the
  // tallest header on the site, which is the right answer for no screen in
  // particular; this replaces it with the one this screen has. Run last, it
  // was behind four other inits, and any one of them throwing left a page
  // offsetting its anchors by a header it is not wearing.
  headerHeight();

  initRoleToggle();
  initToasts();
  initConfirmDialogs();
  initCitySuggest();
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", boot);
} else {
  boot();
}
